import React from "react";
import { Box, Card, CardContent, CardActionArea, Grid2 as Grid, Typography, useTheme, useMediaQuery } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useStyles } from "./CreditRequest.styles";
import StatusLabel from "../StatusLabel/StatusLabel";
import { PendingCreditRequestCardProps } from "./types";

export default function PendingCreditRequestCard(props: PendingCreditRequestCardProps) {
	const classes = useStyles();
	const {
		onView,
		friendlyId,
		lineItems,
		lineStatus,
		invoiceNumber,
		purchaseOrderNumber,
		reason,
		locationId,
		locationName,
		supplierName,
	} = props;
	const onClickViewIcon = () => {
		onView(friendlyId);
	};

	const getAgeOfCreditRequest = () => {
		const dateLineItemCreated = lineItems.find((li) => li.status === lineStatus)?.dateCreated;
		let comparisonDate = new Date();
		comparisonDate.setDate(comparisonDate.getDate() - 1);
		if (dateLineItemCreated && Date.parse(dateLineItemCreated) < comparisonDate.getTime()) {
			return classes.overDue;
		}
		return classes.recent;
	};
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

	return (
		<React.Fragment>
			<Card className={getAgeOfCreditRequest()}>
				<CardContent className={classes.content}>
					<CardActionArea onClick={onClickViewIcon}>
						<Grid container>
							<Grid container size={11} direction="column">
								{Boolean(invoiceNumber) === true && (
									<Box>
										<Typography variant="caption" display="inline" className={classes.text}>
											Invoice No:
										</Typography>
										<Typography variant="body2" display="inline" className={classes.text} color="secondary">
											{" " + invoiceNumber}
										</Typography>
									</Box>
								)}
								<Box>
									<Typography variant="caption" display="inline" className={classes.text}>
										PO No:
									</Typography>
									<Typography variant="body2" display="inline" className={classes.text}>
										{" " + purchaseOrderNumber}
									</Typography>
								</Box>
								<Box>
									<Typography variant="caption" display="inline" className={classes.text}>
										Credit Request No:
									</Typography>
									<Typography variant="body2" display="inline" className={classes.text}>
										{" " + friendlyId}
									</Typography>
								</Box>
								<Box>
									<Typography variant="caption" display="inline" className={classes.text}>
										Reason:
									</Typography>
									<Typography variant="body2" display="inline" className={classes.text}>
										{" " + reason}
									</Typography>
								</Box>
								<Box>
									<Typography variant="caption" display="inline" className={classes.text}>
										Store:
									</Typography>
									<Typography variant="body2" display="inline" className={classes.text}>
										{" " + locationId + " - " + locationName}
									</Typography>
								</Box>
								<Box>
									<Typography variant="caption" display="inline" className={classes.text}>
										Supplier:
									</Typography>
									<Typography variant="body2" display="inline" className={classes.text}>
										{" " + supplierName}
									</Typography>
								</Box>
							</Grid>
							<Grid container size={1} direction="column">
								<Box display="flex" justifyContent="flex-end" className={classes.statusLabel} width="100%">
									<StatusLabel status={lineStatus} size={isMobile ? "mini" : "small"} />
								</Box>
								<Box display="flex" justifyContent="flex-end">
									<ArrowForwardIosIcon />
								</Box>
							</Grid>
						</Grid>
					</CardActionArea>
				</CardContent>
			</Card>
		</React.Fragment>
	);
}
